import { useEffect } from "react";
import { useReducedMotion } from "framer-motion";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Infrastructure from "@/components/site/Infrastructure";
import Stack from "@/components/site/Stack";
import PublicInfo from "@/components/site/PublicInfo";
import Footer from "@/components/site/Footer";

function App() {
  const reduceMotion = useReducedMotion();

  useEffect(() => {
    if (reduceMotion) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, [reduceMotion]);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Infrastructure />
        <Stack />
        <PublicInfo />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" />
    </>
  );
}

export default App;
